import { createEmptyListingAttributes } from './listingAttributesModel';

/** Default shape for advanced search filters (primary + secondary) */
export const createDefaultAdvancedFilters = () => ({
  primary: {
    budget: 0,
    waterbody: [],
    petCharges: null,
    dogsInPool: null,
    trekTrail: [],
    petChargesAmount: 0,
    minRating: 0,
    location: '',
    filterCity: '',
    nearMe: null
  },
  secondary: createEmptyListingAttributes()
});
